import { LibraryVM } from '../view-models/library.viewModel';
import { NoVideos } from '../components/NoVideos';
import { EditVideoModal } from './editVideo.modal';
import { AddFolderModal } from '../components/AddFolderModal';
import { RenameFolderModal } from '../components/RenameFolderModal';
import { DeleteConfirmationModal } from '../components/DeleteConfirmationModal';
import { MoveToFolderModal } from '../components/MoveToFolderModal';
import { LibraryContent } from '../components/LibraryContent';
import { BackToTop } from '../components/BackToTop';
import { BulkActionMenu } from '../components/BulkActionMenu';
import { LibraryFilters } from '../components/LibraryFilters';

export const LibraryView = (p: LibraryVM) => (
  <div className="w-full h-full">
    {p.emptyLibrary ? (
      <NoVideos dispatch={p.dispatch} />
    ) : (
      <div className="flex flex-col gap-8">
        <LibraryFilters {...p} />
        <BulkActionMenu observedId={p.filtersId} bulkAction={p.bulkAction} />
        <LibraryContent {...p} />
        <BackToTop observedId={p.filtersId} />
      </div>
    )}
    {p.openModal.type === 'Edit' && (
      <EditVideoModal
        influencerId={p.influencerId}
        onClose={() => p.dispatch('close')}
        video={p.openModal.value}
        folderId={p.openedFolderId}
        onEditSuccess={() => p.dispatch('refreshList')}
        onReplaceSuccess={(video) => p.dispatch('replaceVideoSuccess', video)}
      />
    )}
    <MoveToFolderModal {...p} />
    <DeleteConfirmationModal {...p} />
    <AddFolderModal {...p} />
    <RenameFolderModal {...p} />
  </div>
);
